import Vue from 'vue';
import Vuex from 'vuex';
import state from './state';
import * as actions from './action';
import mutations from './mutation';
import * as getters from './getter';
import { readFilterMemorySnapshot } from './filterMemory';
// import createLooger from 'vuex/dist/logger'

Vue.use(Vuex);

// const debug = process.env.NODE_ENV !== 'production'
export default new Vuex.Store({
  state: Object.assign({}, state, readFilterMemorySnapshot()),
  actions,
  mutations,
  getters,
  // strict: debug,
  // plugins: debug ? [createLooger()] : []
});



//////////////////
// WEBPACK FOOTER
// ./store/index.js
// module id = null
// module chunks = 